import { Button, Card } from 'antd'
import { useApiContext } from "../../hooks/useApiContext";
import { CloseOutlined} from "@ant-design/icons";
import { LogisticsIems } from "../../services/items";
import React from "react";
import "./styles.css";




const LogisticsSupportQuotation = React.forwardRef((props, ref) => {
  const {logisticsitems, logisticsItemdispatch} = useApiContext()
const deleteItem = (id) => {
    const getitems = logisticsitems.filter((x) => x.id !== id);
    LogisticsIems.delete(logisticsItemdispatch, getitems);
    console.log("Id", logisticsitems);
  };
  
  return (
    <div ref={ref}>
      <Card>
      <br/>
      <br/>
      <br/>
      <br/>
      <b> <h1 className="t-center m-0" >Quotation </h1></b>
       
       
        <h4 className="t-right m-0">Date:<b>{props.Date}</b></h4>
        <h4>To: <b>{props.to}</b></h4>
        <h4>{props.AttnTitle}</h4>
        <h4>{props.Location}</h4>
      
        <h3><u><b>Subject: Quotation for Rental Manpower Services.</b></u> </h3>
  
       <p></p>We provide excellent services to various companies in Kingdom of Saudi Arabia with our skilled, semi-skilled, and non-skilled workers. We are pleased to quote our best and competitive price and wages per/hour mentioned as follow
       
        <table className='table table-bordered'>
            <thead>
                <th className='tablecolor' >SL</th>
                <th className='tablecolor'>DESCRIPTIONS</th>
                <th className='tablecolor'>RATE OF PER {props.rateofper}</th>
               
            </thead>
            <tbody>
              {console.log("Logistics Item :: ", logisticsitems)}
               {logisticsitems && 
               logisticsitems.map((item, i)=>(
                  <tr key={item.id}>
                      <td>{i == 0 ? 1 : i + 1}</td>
                      <td>{item.description}</td>
                      <td >{item.remarks}
                      <Button 
                      style={{ marginLeft: "10px" }}
                      onClick={() => deleteItem(item.id)}
                      danger
                      icon={<CloseOutlined />}
                      size="small"
                      shape="circle"
                      color="white"
                    />
                      </td>
                    
                  </tr>

               ))}
            </tbody>
        </table>
        <table style={{ margin: "20px 10px", width: "100%" }}>
      

            <b/>
            <h2>Terms & Conditions</h2>

        <p>

        <b>01.</b> Daily basic duty will be  	<b>{props.Days}</b> days a week. Fridays, Government holidays or the exceeding duty hours will be charged as overtime, that is 1.5%(as per Saudi Labour Law) of the basic salary<br/>
        <b>02.</b> Food, Accommodation & Transportation will be provided by <b>{props.party}</b>.<br/>

         
        <b>03.</b> Safety gear, gate pass, ID and all other work-related equipment and materials will be provided by <b>{props.to}</b>.<br/>
         <b>04.</b> The contract will be a minimum of <b>{props.Years}</b>  from the signature of both parties.  Labor will move or transfer to any projects, anywhere in Saudi Arabia.<br/>

          
          <b>05.</b> After submission of invoice, payment must be made within <b>{props.InvoiceDays}</b> days.
          <br/>
         <br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<p className="t-center m-0"><b>{props.SpecilArticle}</b></p>

            </p>

            <h3 className="t-center m-0">ALL OTHER FACILITIES AS SAUDI ARABIA LABOR LAW’S.</h3>
         

         
        </table>
        <p>Looking forward to your approval & their mobilization to the project. If you have any questions or need of any clarification above the work, please feel free to contact us.</p>
        <h3>Thank you & Best Regards,</h3>
       
        <b className="fontl">{props.Regardsname}</b><br/>
       <b>{props.Contract}</b><br/>
       <b>{props.Email}</b>



      </Card>
    </div>
  );
});

// export default function EmployeementContractTemplate(
//     {
//         arabicTitle,
//         englishTitle,
//         issueDate,
//         visaNo,
//         idNo,
//         companyName
//     }
// ) {
//   return (
//     <Card title="Employeement Contract" bordered className='container'>
//              <h2 className='t-center m-0'>{arabicTitle}</h2>
//         <h2 className='t-center m-0'>{englishTitle}</h2>
//         <table style={{margin:'20px 10px', width:'100%'}}>
//         <td style={{width:'50%'}}>
//             <h2>Contract ID : {idNo}</h2>

//            <p>
//            This contract was created electronically under the
//                 supervision of the Ministry of Human Resources and
//                 Social Development, Kingdom of Saudi Arabia on
//                 {issueDate}, between:

//             </p>
//             <p><i><b> <u>First Party</u> </b></i> <br />
//             <b>Company/Corporation: {companyName}</b> <br />

//             </p>

//         </td>
//         <td dir='rtl' style={{width:'50%'}}>
//             <h2>رقم العقد:{idNo}</h2>
//             <p>
//             أُبرم هذا العقد الكترونياً تحت إشراف وزارة الموارد البشرية
// والتنمية الاجتماعية، المملكة العربية السعودية في يوم
//  م بين كل من:ق {issueDate}
//             <br />
//             <br />
//             </p>
//             <p><i><b><u>مجموعة تأشيراتنا أدناه</u></b></i> <br />
//             <b>1. رقم التأشيرة : {visaNo}</b>
//             </p>
//         </td>
//         </table>
//     </Card>
//   )
// }

export default LogisticsSupportQuotation;
